import AjaxService from '@services/AjaxService';
import BaseRepository, {SelectOption} from '@repositories/desktop/BaseRepository';

export default class ReportRepository extends BaseRepository {
  protected baseUrl = '';

  public constructor(protected readonly ajaxService: AjaxService) {
    super(ajaxService)
  }

  public getResponsibleUserOptions<T = number | string>(firmId: number|string): Promise<Array<SelectOption<T>>> {
    return this.ajaxService.getJson(`/api/desktop/firms/${firmId}/responsibleUsers/options`
    ).then(r => r.data.attributes.options);
  }

  public sendReportRequest(url: string, mailFormData: any): Promise<any> {
    return this.ajaxService.postFormDataPlain(url, mailFormData);
  }
}
